import { useEffect, useRef } from 'react';

export default function About() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="relative overflow-hidden">
      <div className="flex flex-col md:flex-row">
        <div
          ref={sectionRef}
          className="opacity-0 w-full md:w-3/5 bg-slate-900 px-12 py-24 md:px-20 md:py-32"
        >
          <h2 className="text-5xl font-bold text-white mb-12">About VALIDE d.o.o.</h2>
          
          <div className="space-y-8 max-w-2xl">
            <p className="text-lg text-gray-300 leading-relaxed font-light">
              VALIDE d.o.o. is a team of passionate experts dedicated to developing cutting-edge applications for the iOS platform. Our mission is to create products that not only meet but exceed user expectations in terms of functionality, design, and security.
            </p>
            
            <p className="text-lg text-gray-300 leading-relaxed font-light">
              With years of experience in mobile development, we specialize in crafting intuitive and powerful applications. Our flagship products, including VPN and Cleaner, are designed with a user-first approach, ensuring that every feature enhances the overall mobile experience while maintaining the highest standards of security and privacy.
            </p>
            
            <p className="text-lg text-gray-300 leading-relaxed font-light">
              We believe in continuous innovation and staying ahead of technological trends. Our development philosophy combines elegant design with robust functionality, creating applications that are not only beautiful but also reliable and efficient. Every line of code we write reflects our commitment to quality and our dedication to improving the lives of our users.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed font-light">
              At VALIDE d.o.o., we understand that mobile devices are an integral part of modern life. That's why we focus on creating solutions that protect user data, optimize device performance, and provide seamless experiences. Our team works tirelessly to ensure that every update brings new value and improvements to our users.
            </p>
          </div>
        </div>

        <div className="w-full md:w-2/5 relative bg-gradient-to-br from-teal-400 to-teal-600 min-h-96">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className="absolute w-64 h-64 bg-teal-300/20 rounded-full blur-3xl animate-float"
              style={{ top: '10%', left: '20%', animationDelay: '0s' }}
            ></div>
            <div
              className="absolute w-80 h-80 bg-teal-400/30 rounded-full blur-3xl animate-float"
              style={{ top: '40%', right: '10%', animationDelay: '2s' }}
            ></div>
            <div
              className="absolute w-72 h-72 bg-teal-200/20 rounded-full blur-3xl animate-float"
              style={{ bottom: '10%', left: '30%', animationDelay: '4s' }}
            ></div>
            
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center text-white p-8">
                <i className="ri-smartphone-line text-8xl mb-6 opacity-80"></i>
                <p className="text-2xl font-bold opacity-90">iOS Excellence</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}